import type { PrepaidSettings } from 'app/common/components-next/identifiers/data-types/prepaid-settings'
import * as types from 'app/common/constants/identifiers/types'
import formats from 'app/common/constants/identifiers/formats'

import type { Request } from '../../../index'

type Params = {
  student_id: number | string
}

type ResultDto = {
  enabled: boolean
  types: Array<(typeof types)[keyof typeof types]>
  format: (typeof formats)[keyof typeof formats]
  use_identifiers_new_form: boolean
}

export const convertResult = (res: ResultDto): PrepaidSettings => {
  return {
    enabled: res.enabled,
    types: res.types,
    format: res.format,
    useIdentifiersNewForm: res.use_identifiers_new_form,
  }
}

export const GET_IDENTIFIERS_PREPAID_SETTINGS: Request<Params, PrepaidSettings, void> = [
  'cabinet/identifiers/prepaid/settings',
  'get',
  ['data', 'settings'],
]
